import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "find-a-physician-component" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12 col-md-4" }
const _hoisted_4 = { class: "control-group" }
const _hoisted_5 = {
  for: "find-a-physician-specialty",
  class: "form-label"
}
const _hoisted_6 = { class: "controls" }
const _hoisted_7 = { class: "input-group" }
const _hoisted_8 = { value: "" }
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "col-12 col-md-3" }
const _hoisted_11 = { class: "control-group" }
const _hoisted_12 = {
  for: "find-a-physician-first-name",
  class: "form-label"
}
const _hoisted_13 = { class: "controls" }
const _hoisted_14 = { class: "col-12 col-md-3" }
const _hoisted_15 = { class: "control-group" }
const _hoisted_16 = {
  for: "find-a-physician-last-name",
  class: "form-label"
}
const _hoisted_17 = { class: "controls" }
const _hoisted_18 = { class: "row align-items-center" }
const _hoisted_19 = { class: "col-12 col-md-4" }
const _hoisted_20 = { class: "control-group" }
const _hoisted_21 = {
  for: "find-a-physician-city-or-zip",
  class: "form-label"
}
const _hoisted_22 = { class: "controls" }
const _hoisted_23 = { class: "col-12 col-md-6" }
const _hoisted_24 = { class: "form-check" }
const _hoisted_25 = {
  for: "find-a-physician-ncps-only",
  class: "form-check-label"
}
const _hoisted_26 = { class: "row" }
const _hoisted_27 = { class: "col-12" }
const _hoisted_28 = {
  class: "btn btn-primary",
  type: "submit"
}
const _hoisted_29 = {
  key: 0,
  class: "find-a-physician-component-loading p-3"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "spinner-border",
    role: "status"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
  ])
], -1 /* HOISTED */)
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = {
  key: 1,
  class: "find-a-physician-component-results"
}
const _hoisted_33 = {
  key: 0,
  class: "find-a-physician-component-no-results"
}
const _hoisted_34 = {
  key: 1,
  class: "row"
}
const _hoisted_35 = { class: "find-a-physician-pagination pager py-3" }
const _hoisted_36 = ["disabled"]
const _hoisted_37 = { class: "CurrentPage" }
const _hoisted_38 = ["disabled"]
const _hoisted_39 = {
  class: "row",
  style: {"border-bottom":"1px solid #eeeeee","margin":"20px 0","min-height":"280px"}
}
const _hoisted_40 = { class: "col-12 col-md-4" }
const _hoisted_41 = ["src"]
const _hoisted_42 = { style: {"padding":"10px 0 20px 0"} }
const _hoisted_43 = ["href"]
const _hoisted_44 = { class: "col-12 col-md-8" }
const _hoisted_45 = { class: "row" }
const _hoisted_46 = { class: "col-12 col-md-12" }
const _hoisted_47 = ["href"]
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "department" })
], -1 /* HOISTED */)
const _hoisted_49 = { class: "row" }
const _hoisted_50 = { class: "col-12 col-md-12 mb-2" }
const _hoisted_51 = { class: "physician-detail-label" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_53 = { class: "specialties" }
const _hoisted_54 = { class: "row" }
const _hoisted_55 = { class: "col-12 col-md-12 mb-2" }
const _hoisted_56 = { key: 0 }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_58 = { key: 1 }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_60 = { key: 2 }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_62 = { key: 3 }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_64 = {
  key: 4,
  class: "mt-2"
}
const _hoisted_65 = /*#__PURE__*/_createElementVNode("strong", null, [
  /*#__PURE__*/_createElementVNode("i", {
    "aria-hidden": "true",
    class: "fa fa-phone fa-lg pe-1"
  }),
  /*#__PURE__*/_createTextVNode("  ")
], -1 /* HOISTED */)
const _hoisted_66 = ["content"]
const _hoisted_67 = ["href"]
const _hoisted_68 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_69 = {
  key: 0,
  class: "row mb-2"
}
const _hoisted_70 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 col-md-6" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "Nicklaus Children's Pediatric Specialist",
    class: "imgImage psoa-mobile",
    src: "/NCH/media/img/flat-icons/ncps-logo-01.svg",
    style: {"height":"32px"}
  }),
  /*#__PURE__*/_createTextVNode("  ")
], -1 /* HOISTED */)
const _hoisted_71 = [
  _hoisted_70
]
const _hoisted_72 = { class: "find-a-physician-pagination pager py-3" }
const _hoisted_73 = ["disabled"]
const _hoisted_74 = { class: "CurrentPage" }
const _hoisted_75 = ["disabled"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "title"),
    _createElementVNode("form", {
      id: "physician-search",
      onSubmit: _cache[5] || (_cache[5] = (...args) => ($options.search && $options.search(...args)))
    }, [
      _createElementVNode("fieldset", null, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("label", _hoisted_5, [
                _renderSlot(_ctx.$slots, "specialty")
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _withDirectives(_createElementVNode("select", {
                    id: "find-a-physician-specialty",
                    class: "form-select",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.filterFields.specialty) = $event))
                  }, [
                    _createElementVNode("option", _hoisted_8, [
                      _renderSlot(_ctx.$slots, "choose-specialty")
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.validPhysicianSpecialties, (specialty) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: specialty.id,
                        value: specialty.id
                      }, _toDisplayString(specialty.name), 9 /* TEXT, PROPS */, _hoisted_9))
                    }), 128 /* KEYED_FRAGMENT */))
                  ], 512 /* NEED_PATCH */), [
                    [_vModelSelect, $data.filterFields.specialty]
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("label", _hoisted_12, [
                _renderSlot(_ctx.$slots, "first-name")
              ]),
              _createElementVNode("div", _hoisted_13, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  id: "find-a-physician-first-name",
                  class: "search-query form-control",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.filterFields.firstName) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, $data.filterFields.firstName]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("label", _hoisted_16, [
                _renderSlot(_ctx.$slots, "last-name")
              ]),
              _createElementVNode("div", _hoisted_17, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  id: "find-a-physician-last-name",
                  class: "search-query form-control",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($data.filterFields.lastName) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, $data.filterFields.lastName]
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("label", _hoisted_21, [
                _renderSlot(_ctx.$slots, "in-this-city-or-zip-code")
              ]),
              _createElementVNode("div", _hoisted_22, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  id: "find-a-physician-city-or-zip",
                  class: "search-query form-control",
                  placeholder: "",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($data.filterFields.cityOrZip) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, $data.filterFields.cityOrZip]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _withDirectives(_createElementVNode("input", {
                id: "find-a-physician-ncps-only",
                class: "form-check-input",
                type: "checkbox",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (($data.filterFields.ncpsOnly) = $event))
              }, null, 512 /* NEED_PATCH */), [
                [_vModelCheckbox, $data.filterFields.ncpsOnly]
              ]),
              _createElementVNode("label", _hoisted_25, [
                _renderSlot(_ctx.$slots, "search-only-nicklaus-physicians")
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("button", _hoisted_28, [
              _renderSlot(_ctx.$slots, "search")
            ])
          ])
        ])
      ])
    ], 32 /* HYDRATE_EVENTS */),
    ($data.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_29, _hoisted_31))
      : (_openBlock(), _createElementBlock("div", _hoisted_32, [
          ($options.filteredPhysicians.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                _renderSlot(_ctx.$slots, "no-results-message")
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("button", {
                    onClick: _cache[6] || (_cache[6] = (...args) => ($options.previousPage && $options.previousPage(...args))),
                    class: "Pages border-0",
                    disabled: $data.pageNumber === 1
                  }, [
                    _renderSlot(_ctx.$slots, "previous")
                  ], 8 /* PROPS */, _hoisted_36),
                  _createElementVNode("span", _hoisted_37, _toDisplayString($data.pageNumber), 1 /* TEXT */),
                  _createElementVNode("button", {
                    onClick: _cache[7] || (_cache[7] = (...args) => ($options.nextPage && $options.nextPage(...args))),
                    class: "Pages border-0",
                    disabled: $data.pageNumber === $options.maxPageNumber
                  }, [
                    _renderSlot(_ctx.$slots, "next")
                  ], 8 /* PROPS */, _hoisted_38)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.paginatedPhysicians, (physician) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "col-12 col-md-6",
                    key: _ctx.npi
                  }, [
                    _createElementVNode("div", _hoisted_39, [
                      _createElementVNode("div", _hoisted_40, [
                        _createElementVNode("img", {
                          alt: "physician portrait thumbnail.",
                          class: "img-responsive",
                          style: {"text-align":"center"},
                          height: "120",
                          width: "90",
                          src: physician.image
                        }, null, 8 /* PROPS */, _hoisted_41),
                        _createElementVNode("div", _hoisted_42, [
                          _createElementVNode("a", {
                            class: "btn btn-primary physician-btn",
                            href: physician.url
                          }, [
                            _renderSlot(_ctx.$slots, "profile-details")
                          ], 8 /* PROPS */, _hoisted_43)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_44, [
                        _createElementVNode("div", _hoisted_45, [
                          _createElementVNode("h4", _hoisted_46, [
                            _createElementVNode("a", {
                              class: "physician-list-fullname",
                              href: physician.url
                            }, _toDisplayString(physician.fullName), 9 /* TEXT, PROPS */, _hoisted_47)
                          ])
                        ]),
                        _hoisted_48,
                        _createElementVNode("div", _hoisted_49, [
                          _createElementVNode("div", _hoisted_50, [
                            _createElementVNode("span", _hoisted_51, [
                              _renderSlot(_ctx.$slots, "pediatric-specialty"),
                              _createTextVNode(": ")
                            ]),
                            _hoisted_52,
                            _createElementVNode("span", _hoisted_53, _toDisplayString(physician.specialties.length ? physician.specialties[0].name : ''), 1 /* TEXT */)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_54, [
                          _createElementVNode("div", _hoisted_55, [
                            _createElementVNode("div", null, [
                              _createElementVNode("strong", null, [
                                _renderSlot(_ctx.$slots, "primary-office"),
                                _createTextVNode(": ")
                              ])
                            ]),
                            _createElementVNode("address", null, [
                              (physician.primaryOffice.groupName)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_56, [
                                    _createTextVNode(_toDisplayString(physician.primaryOffice.groupName), 1 /* TEXT */),
                                    _hoisted_57
                                  ]))
                                : _createCommentVNode("v-if", true),
                              (physician.primaryOffice.addressLine1)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_58, [
                                    _createTextVNode(_toDisplayString(physician.primaryOffice.addressLine1), 1 /* TEXT */),
                                    _hoisted_59
                                  ]))
                                : _createCommentVNode("v-if", true),
                              (physician.primaryOffice.addressLine2)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_60, [
                                    _createTextVNode(_toDisplayString(physician.primaryOffice.addressLine2), 1 /* TEXT */),
                                    _hoisted_61
                                  ]))
                                : _createCommentVNode("v-if", true),
                              (physician.primaryOffice.city)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_62, [
                                    _createTextVNode(_toDisplayString(physician.primaryOffice.city) + ", " + _toDisplayString(physician.primaryOffice.state) + ", " + _toDisplayString(physician.primaryOffice.zipCode), 1 /* TEXT */),
                                    _hoisted_63
                                  ]))
                                : _createCommentVNode("v-if", true),
                              (physician.primaryOffice.formattedPhone)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                                    _hoisted_65,
                                    _createElementVNode("span", {
                                      content: physician.primaryOffice.phone,
                                      itemprop: "telephone"
                                    }, [
                                      _createElementVNode("a", {
                                        href: 'tel://' + physician.primaryOffice.formattedPhone
                                      }, [
                                        _createElementVNode("span", null, _toDisplayString(physician.primaryOffice.formattedPhone), 1 /* TEXT */)
                                      ], 8 /* PROPS */, _hoisted_67)
                                    ], 8 /* PROPS */, _hoisted_66)
                                  ]))
                                : _createCommentVNode("v-if", true)
                            ])
                          ]),
                          _hoisted_68
                        ]),
                        (physician.ncps)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_69, _hoisted_71))
                          : _createCommentVNode("v-if", true)
                      ])
                    ])
                  ]))
                }), 128 /* KEYED_FRAGMENT */)),
                _createElementVNode("div", _hoisted_72, [
                  _createElementVNode("button", {
                    onClick: _cache[8] || (_cache[8] = (...args) => ($options.previousPage && $options.previousPage(...args))),
                    class: "Pages border-0",
                    disabled: $data.pageNumber === 1
                  }, [
                    _renderSlot(_ctx.$slots, "previous")
                  ], 8 /* PROPS */, _hoisted_73),
                  _createElementVNode("span", _hoisted_74, _toDisplayString($data.pageNumber), 1 /* TEXT */),
                  _createElementVNode("button", {
                    onClick: _cache[9] || (_cache[9] = (...args) => ($options.nextPage && $options.nextPage(...args))),
                    class: "Pages border-0",
                    disabled: $data.pageNumber === $options.maxPageNumber
                  }, [
                    _renderSlot(_ctx.$slots, "next")
                  ], 8 /* PROPS */, _hoisted_75)
                ])
              ]))
        ]))
  ]))
}